import type { Definition } from '~/types'
import imageSizes from '../../constants/imageSizes'

export const ModuleExpandableCard: Definition = {
  contentType: 'ModuleExpandableCard',
  fields: [
    {
      id: 'icon',
      name: 'Icon',
      type: 'Symbol'
    },
    {
      id: 'eyebrow',
      name: 'Eyebrow',
      type: 'Symbol'
    },
    {
      id: 'title',
      name: 'Title',
      type: 'Symbol'
    },
    {
      id: 'description',
      name: 'Description',
      type: 'Symbol'
    },
    {
      id: 'media',
      name: 'Image or video (optional)',
      type: ['ModuleMedia', 'ModuleVideo', 'ModuleInternalVideo']
    },
    {
      id: 'link',
      name: 'Link',
      type: 'ModuleNavigationLink'
    },
    {
      id: 'benefit1Icon',
      name: 'Benefit 1 Icon',
      type: 'Symbol'
    },
    {
      id: 'benefit1Title',
      name: 'Benefit 1 Title',
      type: 'Symbol'
    },
    {
      id: 'benefit1Text',
      name: 'Benefit 1 Text',
      type: 'Symbol'
    },
    {
      id: 'benefit2Icon',
      name: 'Benefit 2 Icon',
      type: 'Symbol'
    },
    {
      id: 'benefit2Title',
      name: 'Benefit 2 Title',
      type: 'Symbol'
    },
    {
      id: 'benefit2Text',
      name: 'Benefit 2 Text',
      type: 'Symbol'
    },
    {
      id: 'benefit3Icon',
      name: 'Benefit 3 Icon',
      type: 'Symbol'
    },
    {
      id: 'benefit3Title',
      name: 'Benefit 3 Title',
      type: 'Symbol'
    },
    {
      id: 'benefit3Text',
      name: 'Benefit 3 Text',
      type: 'Symbol'
    },
    {
      id: 'benefit4Icon',
      name: 'Benefit 4 Icon',
      type: 'Symbol'
    },
    {
      id: 'benefit4Title',
      name: 'Benefit 4 Title',
      type: 'Symbol'
    },
    {
      id: 'benefit4Text',
      name: 'Benefit 4 Text',
      type: 'Symbol'
    },
    {
      id: 'benefit5Icon',
      name: 'Benefit 5 Icon',
      type: 'Symbol'
    },
    {
      id: 'benefit5Title',
      name: 'Benefit 5 Title',
      type: 'Symbol'
    },
    {
      id: 'benefit5Text',
      name: 'Benefit 5 Text',
      type: 'Symbol'
    }
  ]
}

export const PageUplift: Definition = {
  contentType: 'PageUplift',
  fields: [
    {
      id: 'hero',
      name: 'Hero',
      type: 'BlockContent',
      imageOptions: { sizes: imageSizes.hero }
    },
    {
      id: 'contentBlock1',
      name: 'Content Block 1',
      type: 'BlockContent',
      imageOptions: { sizes: imageSizes.columns12_52, lazy: true }
    },
    {
      id: 'contentBlock2Title',
      name: 'Content Block 2 Title',
      type: 'Symbol'
    },
    {
      id: 'contentBlock2',
      name: 'Content Block 2 Expandable Cards',
      type: 'Array',
      subType: 'ModuleExpandableCard',
      validations: [{ size: { min: 1, max: 3 } }],
      imageOptions: [
        // Thumbnail
        {
          sizes: imageSizes.columns4_169
        },
        // Modal
        {
          sizes: imageSizes.columns10_169
        }
      ]
    },
    {
      id: 'quote',
      name: 'Quote',
      type: 'BlockQuote'
    },
    {
      id: 'upliftTitle',
      name: 'upliftTitle',
      type: 'Symbol'
    },
    {
      id: 'items',
      name: 'Uplift detail Items',
      type: 'Array',
      subType: 'PageUpliftDetail',
      validations: [{ size: { min: 0, max: 10 } }]
    },
    {
      id: 'upliftTitleList',
      name: 'Uplift Title List',
      type: 'Array',
      subType: 'Symbol',
      validations: [{ size: { min: 1, max: 3 } }],
      localized: true
    },
    {
      id: 'upliftCards',
      name: 'Uplift Cards',
      type: 'Array',
      subType: 'ModuleMediaCard',
      validations: [{ size: { min: 1, max: 3 } }],
      imageOptions: { sizes: imageSizes.columns4_11 }
    },
    {
      id: 'logoBar',
      name: 'Logo bar',
      type: 'BlockLogoBar'
    },
    {
      id: 'cta',
      name: 'Call to action',
      type: 'BlockCallToAction'
    },
    {
      id: 'footnotes',
      name: 'Footnotes',
      type: 'RichText'
    },
    {
      id: 'notificationBar',
      name: 'Notification Bar',
      type: 'BlockNotificationBar'
    },
    {
      id: 'metrics',
      name: 'Highlight metrics',
      type: 'BlockMetrics'
    },
    {
      id: 'webinar',
      name: 'Webinar highlight',
      type: 'BlockContent',
      validations: [{ size: { min: 0, max: 1 } }],
      imageOptions: { sizes: imageSizes.columns6_11 }
    },
    {
      id: 'relatedContent',
      name: 'Related content',
      type: 'BlockRelatedContent'
    },
    {
      id: 'video',
      name: 'Explainer video',
      type: ['ModuleVideo', 'ModuleInternalVideo'],
      imageOptions: { sizes: imageSizes.columns12_169, lazy: true }
    }
  ]
}

export const PageUpliftDetail: Definition = {
  contentType: 'PageUpliftDetail',
  fields: [
    {
      id: 'hero',
      name: 'Hero',
      type: 'BlockContent',
      imageOptions: { sizes: imageSizes.hero }
    },
    {
      id: 'productName',
      name: 'Product Name',
      type: 'Symbol'
    },
    {
      id: 'productIcon',
      name: 'Product Icon',
      type: 'Symbol'
    },
    {
      id: 'usp',
      name: 'Usps',
      type: 'Array',
      subType: 'ModuleUsp'
    },
    {
      id: 'logoBar',
      name: 'Logo bar',
      type: 'BlockLogoBar'
    },
    {
      id: 'contentBlock1',
      name: 'Content block 1',
      type: 'BlockContent',
      imageOptions: { sizes: imageSizes.columns12_5269, lazy: true }
    },
    {
      id: 'contentBlock2',
      name: 'Content block 2',
      type: 'BlockGroup',
      subType: 'BlockContent',
      imageOptions: { sizes: imageSizes.columns6_11, lazy: true }
    },
    {
      id: 'quote',
      name: 'Quote',
      type: 'BlockQuote'
    },
    {
      id: 'highlightBlock',
      name: 'Highlight Block',
      type: 'BlockHighlight',
      imageOptions: { sizes: imageSizes.columns6_11, lazy: true }
    },
    {
      id: 'upliftTitle',
      name: 'upliftTitle',
      type: 'Symbol'
    },
    {
      id: 'items',
      name: 'Uplift detail Items',
      type: 'Array',
      subType: 'PageUpliftDetail',
      validations: [{ size: { min: 0, max: 10 } }]
    },
    {
      id: 'faqs',
      name: 'FAQ',
      type: 'BlockFaqGroup'
    },
    {
      id: 'relatedContent',
      name: 'Related content',
      type: 'BlockRelatedContent'
    },
    {
      id: 'cta',
      name: 'Call to action',
      type: 'BlockCallToAction'
    },
    {
      id: 'footnotes',
      name: 'Footnotes',
      type: 'RichText'
    },
    {
      id: 'notificationBar',
      name: 'Notification Bar',
      type: 'BlockNotificationBar'
    }
  ]
}

export default {
  ModuleExpandableCard,
  PageUplift,
  PageUpliftDetail
}
